import { useCallback, useContext } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { SET_SEARCH_BURN_ENABLED } from 'actions/actionConstants'
import SearchBurnContext from 'contexts/SearchPointsContext'

function useSearchBurnEnabled() {
  const dispatch = useAppDispatch()
  const hasSelectedBurnToggle = useAppSelector(state => state.loyalty.hasSelectedBurnToggle)
  const context = useContext(SearchBurnContext)

  const setSearchBurnEnabled = useCallback((enabled: boolean) => {
    dispatch({ type: SET_SEARCH_BURN_ENABLED, enabled })
    if (!enabled) {
      context.setBurnUserBalance(false)
      context.setPointsToBurn(undefined)
    }
  }, [dispatch, context])

  return {
    hasSelectedBurnToggle,
    setSearchBurnEnabled,
    ...context,
  }
}

export default useSearchBurnEnabled
